export default () => ({
  userAgent: {}
})
